// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0b0463d4","545":"95bfa3fb"}[chunkId] + ".chunk.js";
};